import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AuthService, AuthUser } from '../../services/auth.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false,
    animations: [
      trigger('slideDown', [
        transition(':enter', [
          style({ height: '0', opacity: 0, overflow: 'hidden' }),
          animate('300ms ease-out', style({ height: '*', opacity: 1 }))
        ]),
        transition(':leave', [
          style({ height: '*', opacity: 1, overflow: 'hidden' }),
          animate('300ms ease-in', style({ height: '0', opacity: 0 }))
        ])
      ])
    ]
})
export class NavbarComponent implements OnInit {
  showAdminConsole: boolean = true;
  currentUser: AuthUser | null = null;

  constructor(private authService : AuthService) { }

  ngOnInit(): void {
    this.authService.authState$.subscribe(user => {
      this.currentUser = user;
    });
  }

  toggleAdminConsole(): void {
    this.showAdminConsole = !this.showAdminConsole;
  }

  signOut(): void {
    this.authService.logout();
  }

  get isAdmin(): boolean {
    return this.currentUser?.role === 'admin';
  }

  get isMember(): boolean {
    return this.currentUser?.role === 'member';
  }

  get isRecruiter(): boolean {
    return this.currentUser?.role === 'recruiter';
  }

}
